import React from "react";
import {
    Box,
    Heading,
    Flex,
    Button,
    InputGroup,
    InputLeftElement,
    Input,
    useColorModeValue,
    Icon
} from "@chakra-ui/react";
import {FiSearch} from "react-icons/fi";
import {ColorModeSwitcher} from "../../ColorModeSwitcher";
import {useKeycloak} from "@react-keycloak/web";
import {Link as RouterLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

interface HeaderProps {
    passSearchToParent: (searchString: React.SetStateAction<string>) => void;
}

function Header({passSearchToParent}: HeaderProps) {
    const {t} = useTranslation();
    const [show, setShow] = React.useState(false);
    const handleToggle = () => setShow(!show);
    const {keycloak,} = useKeycloak();
    const bg = useColorModeValue("gray.200", "gray.800")
    const color = useColorModeValue("gray.800", "gray.200")
    return (
        <Flex
            as="nav"
            align="center"
            justify="space-between"
            wrap="wrap"
            padding="1.5rem"
            bg={bg}
            color={color}
            position="fixed"
            top="0"
            width="100%"
            zIndex="100"
        >
            <Flex align="center" mr={5}>
                <RouterLink to={`/`}>
                    <Heading as="h1" size="lg" letterSpacing={"-.1rem"}>
                        {t('app_name')}
                    </Heading>
                </RouterLink>
            </Flex>

            <Box display={{base: "none", sm: "block", md: "none"}} onClick={handleToggle}>
                <svg
                    fill="gray"
                    width="12px"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <title>Menu</title>
                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
                </svg>
            </Box>

            <Box
                display={{sm: show ? "block" : "none", md: "flex"}}
                width={{sm: "full", md: "auto"}}
                alignItems="center"
                flexGrow={1}
            >
                <InputGroup style={{width: "240px"}}>
                    <InputLeftElement
                        pointerEvents="none"
                        children={<Icon as={FiSearch}/>}
                    />
                    <Input variant="flushed" bg={bg} color={color} colorScheme = "gray" focusBorderColor={color} onChange={(event) => passSearchToParent(event.target.value)} type="search" placeholder={t('header.search')+'...'} />
                </InputGroup>
            </Box>

            <Box
                display={{sm: show ? "block" : "none", md: "block"}}
                mt={{base: 4, md: 0}}
            >
                <Button onClick={() => keycloak.logout()} bg="transparent" border="1px">
                    {t('header.logout')}
                </Button>
                <ColorModeSwitcher/>
            </Box>
        </Flex>
    );
}

export default Header;
